import Vue from 'vue'
import Child from './Child'
// import { Button, Card, Checkbox, Row, Col, Popover, Table } from 'element-ui'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import JsonCSV from 'vue-json-csv'
import VueClipboard from 'vue-clipboard2'
// import 'element-ui/lib/theme-chalk/index.css'
// import lang from 'element-ui/lib/locale/lang/en'
// import locale from 'element-ui/lib/locale'

// Custom components that are registered globaly.
[
  Child
].forEach(Component => {
  Vue.component(Component.name, Component)
})

Vue.component('downloadCsv', JsonCSV)

// ElementUI components that are registered globaly.
// Vue.use(Button)
// Vue.use(Card)
// Vue.use(Checkbox)
// Vue.use(Row)
// Vue.use(Col)
// Vue.use(Popover)
// Vue.use(Table)
Vue.use(ElementUI, { locale })
Vue.use(VueClipboard)

// configure language
// locale.use(lang)


// WEBPACK FOOTER //
// /resources/js/components/index.js